<div layout="row"
     class="layout-row layout-align-start-center"
     (mouseenter)="isShowCopyBtn=true"
     (mouseleave)="isShowCopyBtn=false"
     [ngbTooltip]="tooltipTmpl"
     openDelay="300">

  <app-bringoz-state-link [state]="'accounts-detail-demand.active-deliveries'"
                          [permission]="'accounts.demand.get'"
                          [params]="{id: account.id}"
                          [text]="account.name">

  </app-bringoz-state-link>

  <app-text-copy-button *ngIf="isAllowCopyButton" [text]="account.name"
                        [isShowCopyBtn]="isShowCopyBtn"></app-text-copy-button>

</div>


<ng-template #tooltipTmpl>
  <div class="layout-row padding-10">
    <div class="layout-column">
      <div class="layout-row layout-align-start-center br-body-2">
        <bringoz-icon iconName="account"></bringoz-icon>
        <span class="br-body-2">{{account.name}}</span>
      </div>
      <div class="layout-row layout-align-start-center br-body-2">
        <bringoz-icon iconName="phone"></bringoz-icon>
        <span appBringozPpi class="br-body-2">{{account.phoneNumber | bringozPhone}}</span>
      </div>
    </div>
  </div>
</ng-template>
